import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import Content from "../../content/Content";
import Store from "../../content/Store";
import TabNavWithHeader from "../shared/navigation/TabNavWithHeader";
import HelpSection from "../shared/HelpSection";
import { Layouts } from "../../constants/Constants";
import styles from "../../assets/css/modules/myprofile/myprofile.css";
import PromoImageCard from "../shared/PromoImageCard";
import FileDownloadList from "../download/FileDownloadList";
import { Paths, Urls } from "../../constants/UrlConstants";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";

const mapStateToProps = (state) => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;
  return {
    isHOL: state.layoutReducer && state.layoutReducer.layout === Layouts.HOL,
    IsLapsed: selectedPolicy && selectedPolicy.IsLapsed,
    IsInternational: selectedPolicy && selectedPolicy.IsInternational,
    IsSaga: selectedPolicy && selectedPolicy.IsSaga,
    PersonConsent: selectedPolicy && selectedPolicy.PersonConsent,
    HideContactPrefs:
      selectedPolicy &&
      selectedPolicy.IsLapsed &&
      !selectedPolicy.PersonConsent,
    isLargeCorporate: selectedPolicy && selectedPolicy.IsLargeCorporate,
    IsChildOnlyPolicy: selectedPolicy && selectedPolicy.IsChildOnlyPolicy,
    featureFlagEP: state.unreadMessagesReducer && state.unreadMessagesReducer.featureFlagEP,
    IsInternalView: state.policyReducer && state.policyReducer.policyDetails 
    && state.policyReducer.policyDetails.IsInternalView,
  };
};

const getPromo = (isChildOnlyPolicy) => {
  const obj = (isChildOnlyPolicy ? Store?.Permissions?.HealthSupport : Store?.Permissions?.GP247) ?? {};

  return <PromoImageCard
    ImgSrc={obj.IconSrc}
    ImgSrcMobile={obj.IconSrcMobile}
    Heading={obj.Heading}
    Description={obj.Description}
    LinkText={obj.LinkText}
    LinkTo={obj.LinkTo}
    LeftImage
  />;
};

class Permissions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      url: Urls.EngagementPortal[EPDomain_ROOT].new
    };
   }

   handleCallback=(data)=>{
    this.setState({ url: data });
  }


  render() {
    return this.props.IsSaga || this.props.IsInternational ? (
      <Redirect to={Paths.NotFound} />
    ) : (
      <div className={styles.myProfile}>
        <TabNavWithHeader
          heading={Store.MyProfileHeader.Heading}
          links={
            this.props.HideContactPrefs
              ? Store.MyProfileHeader.LinksWithoutPreferences
              : Store.MyProfileHeader.Links
          }
          backgroundColourClass={styles.backgroundColourClass}
          currentLinkIndex={this.props.HideContactPrefs ? 1 : 2}
        />
        <EPQueryParams url={this.state.url} messageType="changeDetails" updatedURL={this.handleCallback}/>
        <ShadowedContainer>
          <div className="row">
            <div className="col-md-12">
              <div className={styles.myProfileContainer}>
                <h2>
                  <Content name={Store.Permissions.PermissionsHeader} />
                </h2>
                <p>
                  <Content name={Store.Permissions.PermissionsDesc} />
                </p>
                <Content name={Store.Permissions.Files}>
                  {(contentifiedFiles) => (
                    <FileDownloadList
                      files={contentifiedFiles}
                      useDirectLinkDownload
                    />
                  )}
                </Content>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className={styles.helpSection}>
                <HelpSection
                  HeadingLinkText={
                    Store.Permissions.HelpSection.HeadingLinkText
                  }
                  HeadingLinkTo={Store.Permissions.HelpSection.HeadingLinkTo}
                  MoreHelpLinkText={
                    Store.Permissions.HelpSection.MoreHelpLinkText
                  }
                  MoreHelpLinkTo={Store.Permissions.HelpSection.MoreHelpLinkTo}
                  HelpSet={
                    this.props.featureFlagEP === false || this.props.featureFlagEP === undefined ?
                    Store.Permissions.HelpSection.Faq:
                    Store.Permissions.HelpSection.FaqEP(this.state.url,this.props.IsInternalView)
                  }
                />
              </div>
            </div>
          </div>
        </ShadowedContainer>
        {!this.props.isHOL &&
          !this.props.isLargeCorporate &&
          !this.props.IsLapsed ? (
          <div className={"home " + styles.healthStore}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {getPromo(this.props.IsChildOnlyPolicy)}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Permissions);
